import R from 'app/assets/R'
import { BaseCol } from 'app/components/common/BaseCol'
import { BaseSpace } from 'app/components/common/BaseSpace'
import BaseText from 'app/components/common/BaseText'
import { SectionBase } from 'app/components/common/SectionBase'
import HeaderPage from 'app/components/header/components/HeaderPage'
import { BaseTableManagement } from 'app/components/tables/BaseTableManagement'
import React from 'react'
import { CreateTumModal } from './components'
import { useHook } from './hook'
import * as S from './styles'
import { FilterLayout } from '../TradeUnionMemberManagement/components'

const TradeUnionMemberManagement: React.FC = () => {
  const {
    columns,
    pagination,
    filter,
    onChangeFilter,
    handleChangePagination,
    isLoading,
    data,
    isPermissionCreate,
    downloadExcel,
    isPermissionDownload,
    user,
    t,
  } = useHook()

  return (
    <S.ScrollWrapper>
      <HeaderPage
        title={`${t(R.strings.tum_your_unit_management)} "${
          user?.member?.unit?.name
        }"`}
        rightComponent={
          isPermissionCreate ? (
            <>
              {isPermissionCreate ? (
                <>
                  <BaseCol>
                    <CreateTumModal />
                  </BaseCol>
                </>
              ) : null}
            </>
          ) : undefined
        }
        isExport={isPermissionDownload}
        onPressExport={downloadExcel}
      />

      <SectionBase>
        <BaseSpace size={0}>
          <FilterLayout
            filter={filter}
            onChangeFilter={onChangeFilter}
            isWithoutUnit
          />
          <BaseTableManagement
            columns={columns}
            dataSource={data}
            pagination={{
              ...pagination,
              total: pagination.total,
              showTotal: total => (
                <BaseText children={`Tổng: ${total}`} fontWeight="bold" />
              ),
              showSizeChanger: true,
            }}
            loading={isLoading}
            onChange={handleChangePagination}
            rowClassName="row-overwrite-style"
          />
        </BaseSpace>
      </SectionBase>
    </S.ScrollWrapper>
  )
}

export default TradeUnionMemberManagement
